import { getCdnUrl } from "owa-config";

export type FaviconScenario = "MailRead" | "MailCompose" | "Calendar" | "Reminder";

const FAVICON_CDN_PATH = "assets/native-host/icons/";

const FAVICON_FILE_NAMES: Record<FaviconScenario, string> = {
    MailRead: "mailread_v2.ico",
    MailCompose: "mailcompose_v2.ico",
    Calendar: "appointment_v2.ico",
    Reminder: "reminder_v2.ico",
};

export default function getScenarioFaviconUrl(scenario: FaviconScenario): string {
    const cdnUrl = getCdnUrl();
    const absoluteCdnUrl = cdnUrl.startsWith("//") ? `https:${cdnUrl}` : cdnUrl;
    return `${absoluteCdnUrl}${FAVICON_CDN_PATH}${FAVICON_FILE_NAMES[scenario]}`;
}
